<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000002') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select
				v-model="data"
				placeholder="공장선택"
				style="height: 40px"
				@change="
					value => {
						return setSearchParam({ key: 'plantCd', value: value });
					}
				"
			>
				<el-option v-for="(plant, index) in plants" :label="plant.commCdName" :value="plant.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	created() {
		this.getPlants_().catch(error => {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			Promise.reject(error);
		});
		this.data = this.searchParams.plantCd;
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
